import styles from "./index.module.scss"
import cn from "classnames";
import React, { useRef, useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { LanguagesIcon } from "lucide-react";
import { useClickOutside } from "../../hooks/useClickOutside";

const LanguageSelector = () => {
  const { currentLanguage, availableLanguages, changeLanguage, isLoading } = useLanguage();

  const handleLanguageChange = (event) => {
    changeLanguage(event.target.value);
  };

  return (
    <div className={styles.languageSelector}>
      <select
        value={currentLanguage}
        onChange={handleLanguageChange}
        disabled={isLoading}
        className={styles.languageSelect}
      >
        {availableLanguages.map((language) => (
          <option key={language.code} value={language.code}>
            {language.name}
          </option>
        ))}
      </select>
      {isLoading && <span className={styles.loadingIndicator}>⌛</span>}
    </div>
  );
};

export const LanguageDropdown = ({isSideBar = false}) => {
  const { currentLanguage, availableLanguages, changeLanguage, isLoading } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useClickOutside(dropdownRef, () => setIsOpen(false));

  const currentLangObj = availableLanguages.find((lang) => lang.code === currentLanguage);

  return (
    <div className={styles.languageDropdown} ref={dropdownRef}>
      <div className={styles.currentLanguage} onClick={() => setIsOpen((prev) => !prev)}>
        <LanguagesIcon />
        <span>
          {currentLangObj?.shortName || currentLanguage.toUpperCase()}
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"
            style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}>
            <path d="M16.9999 9.67C16.8126 9.48375 16.5591 9.37921 16.2949 9.37921C16.0308 9.37921 15.7773 9.48375 15.5899 9.67L11.9999 13.21L8.45995 9.67C8.27259 9.48375 8.01913 9.37921 7.75495 9.37921C7.49076 9.37921 7.23731 9.48375 7.04995 9.67C6.95622 9.76297 6.88183 9.87357 6.83106 9.99543C6.78029 10.1173 6.75415 10.248 6.75415 10.38C6.75415 10.512 6.78029 10.6427 6.83106 10.7646C6.88183 10.8864 6.95622 10.997 7.04995 11.09L11.2899 15.33C11.3829 15.4237 11.4935 15.4981 11.6154 15.5489C11.7372 15.5997 11.8679 15.6258 11.9999 15.6258C12.132 15.6258 12.2627 15.5997 12.3845 15.5489C12.5064 15.4981 12.617 15.4237 12.7099 15.33L16.9999 11.09C17.0937 10.997 17.1681 10.8864 17.2188 10.7646C17.2696 10.6427 17.2957 10.512 17.2957 10.38C17.2957 10.248 17.2696 10.1173 17.2188 9.99543C17.1681 9.87357 17.0937 9.76297 16.9999 9.67Z" fill="#212121"/>
          </svg>
        </span>
        {isLoading && <span className={styles.loadingIndicator}> ⌛</span>}
      </div>

      {isOpen && (
        <div className={cn(styles.dropdownContent, {
          [styles.dropdownContent__sideBar]: isSideBar,
        })}>
          {availableLanguages.map((language) => (
            <button
              key={language.code}
              onClick={() => {
                changeLanguage(language.code);
                setIsOpen(false);
              }}
              disabled={isLoading || language.code === currentLanguage}
              className={cn(styles.languageOption, {
                  [styles.active]: language.code === currentLanguage,
              })}
            >
              {language.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;